import { useEditorState } from '@tiptap/react'
import type { CSSProperties } from 'react'
import { Icon } from '@opallabs/lapidary'
import { ColorRadioGroup } from '@opallabs/satellite'
import { useTextEditor } from '../../context'
import { ControlButtonPopover } from './ControlButtonPopover'
import * as styles from './styles'

export const TextColorControlButton = () => {
  const { editor } = useTextEditor()
  const activeColor: string | null = useEditorState({
    editor,
    selector: (snapshot) =>
      snapshot.editor.getAttributes('textStyle').color ?? null,
  })

  const handleSelectColor = (color: string | null) => {
    if (color === null) {
      editor.chain().focus().unsetColor().run()
    } else {
      editor.chain().focus().setColor(color).run()
    }
  }

  return (
    <div
      css={styles.colorPopoverButtonWrapper}
      style={{ '--active-color': activeColor } as CSSProperties}
    >
      <ControlButtonPopover
        align="start"
        displayMenuIndicator={false}
        icon={<Icon glyph="gem-no-text-color" ariaHidden />}
        label="Color"
      >
        <div css={styles.colorPopoverContent}>
          <ColorRadioGroup
            useDefaultColors={true}
            hideColorInput={false}
            nullColor="#000"
            onInputColor={handleSelectColor}
            onSelectColor={handleSelectColor}
            selectedColor={activeColor}
          />
        </div>
      </ControlButtonPopover>
    </div>
  )
}
